var exports = {
  "Ve": "ThemeTab.module__themeButtonGroup___WTV1Qm",
  "mB": "ThemeTab.module__themeButton___WTV1Qm",
  "RL": "ThemeTab.module__themeButtonSelected___WTV1Qm",
  "Uk": "ThemeTab.module__themeButtonLight___WTV1Qm",
  "sy": "ThemeTab.module__themeButtonDark___WTV1Qm",
  "H2": "ThemeTab.module__themeButtonIcon___WTV1Qm",
  "zO": "ThemeTab.module__themeButtonCheckmark___WTV1Qm",
  "Qs": "ThemeTab.module__themeButtonCheckmarkIcon___WTV1Qm",
};

module.exports = exports;
